/** Exact WebReg season/year encodings for the eight currently supported terms.
 * This is URL context only, not registration eligibility or enrollment authority.
 */
const WEBREG_SEMESTER_SELECTIONS = {
  'spring-2027': '12027',
  'winter-2027': '02027',
  'fall-2026': '92026',
  'summer-2026': '72026',
  'spring-2026': '12026',
  'fall-2025': '92025',
  'winter-2025': '02025',
  'spring-2025': '12025',
} as const;

/** Caller owns the existing missing-term fallback; unknown explicit terms refuse. */
export function webRegSemesterSelection(termId: string): string | null {
  return Object.hasOwn(WEBREG_SEMESTER_SELECTIONS, termId)
    ? WEBREG_SEMESTER_SELECTIONS[termId as keyof typeof WEBREG_SEMESTER_SELECTIONS]
    : null;
}
